import { render } from "./NimbusDataTable.vue?vue&type=template&id=d144db7e"
import script from "./NimbusDataTable.vue?vue&type=script&lang=js"
export * from "./NimbusDataTable.vue?vue&type=script&lang=js"

import "./NimbusDataTable.vue?vue&type=style&index=0&id=d144db7e&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__